import { NeedsResourceDetailsDto } from '@act/shared/data-transfer-objects';
import {
  ResourcingDetailsEventPayload,
  ResourcingEventTypes,
} from '@act/shared/socket-events';
import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import { ResourcingState } from 'redux/types/resourcingTypes';
import type { WebsocketEventActions } from '../types/websocket-types';
import { resetRedux } from '../actions/shared-actions';

// THUNKS/ACTIONS ==============================================================

// INITIAL STATE ===============================================================
const resourceDetailsAdapter = createEntityAdapter<NeedsResourceDetailsDto>();

const initialState: ResourcingState = {
  status: 'initial',
  resourcingDetails: resourceDetailsAdapter.getInitialState(),
};

// SLICE =======================================================================
export const resourcingSlice = createSlice({
  name: 'resourcing',
  initialState,
  reducers: {
    // resourcing websockets =============================
    resourceUpserted: (
      state: ResourcingState,
      action: PayloadAction<ResourcingDetailsEventPayload>
    ) => {
      resourceDetailsAdapter.upsertOne(
        state.resourcingDetails,
        action.payload.resourcingDetails
      );
    },
  },
  extraReducers: builder => {
    builder.addCase(resetRedux, state => {
      state = { ...initialState };
      return state;
    });
  },
});

// REDUCER =====================================================================
export const resourcingReducer = resourcingSlice.reducer;

// SELECTORS ===================================================================
// EXPORT HELPER ===============================================================
// EFFECTS =====================================================================

// WEBSOCKET ACTIONS ======================================
export const resourcingSliceWebsocketActions: WebsocketEventActions[] = [
  {
    type: ResourcingEventTypes.RESOURCING_DETAILS_UPSERTED,
    action: resourcingSlice.actions.resourceUpserted,
    channel: 'baseSocket',
  },
];
